"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _Box = _interopRequireDefault(require("@commerce-ui/core2/Box"));
var _LinkRaw = _interopRequireDefault(require("@commerce-ui/core2/LinkRaw"));
var _react = _interopRequireDefault(require("react"));
var _RouteContext = require("@deosite/lib/RouteContext");
var __jsx = _react["default"].createElement;
var CategorySubmenu = function CategorySubmenu(props) {
  var _submenu$subcategorie;
  var submenu = props.submenu,
    _props$underlineAsAct = props.underlineAsActive,
    underlineAsActive = _props$underlineAsAct === void 0 ? false : _props$underlineAsAct,
    _props$hasNoChildren = props.hasNoChildren,
    hasNoChildren = _props$hasNoChildren === void 0 ? false : _props$hasNoChildren;
  var _useRouteContext = (0, _RouteContext.useRouteContext)(),
    Link = _useRouteContext.Link;
  var isSale = submenu.special && submenu.special === "sale";
  var hasNoSubcategories = ((_submenu$subcategorie = submenu.subcategories) === null || _submenu$subcategorie === void 0 ? void 0 : _submenu$subcategorie.length) === 0;
  return __jsx(_Box["default"], {
    as: "ul",
    key: "fragment-" + submenu.name,
    sx: {
      width: "180px",
      mb: hasNoChildren ? "s5" : hasNoSubcategories ? "s6" : "s9"
    }
  }, __jsx(_Box["default"], {
    as: "li",
    sx: {
      font: hasNoChildren ? "s_sans" : "base_sans_bold",
      color: isSale ? "negative" : "main",
      textDecoration: underlineAsActive ? "underline" : "none",
      "&:hover": {
        textDecoration: hasNoChildren ? "underline" : "none"
      },
      mb: hasNoChildren ? 0 : "s6"
    }
  }, __jsx(Link, {
    route: "category-page",
    params: submenu
  }, __jsx(_LinkRaw["default"], {
    title: submenu.name
  }, submenu.name))), __jsx(_Box["default"], null, submenu.subcategories && Object.keys(submenu.subcategories).map(function (item, index) {
    return __jsx(_Box["default"], {
      as: "ul",
      key: "submenuLinks-" + index,
      sx: {
        width: "180px"
      }
    }, __jsx(_Box["default"], {
      as: "li",
      sx: {
        font: "s_sans",
        color: "main",
        mt: "s5",
        width: "180px",
        "&:hover": {
          textDecoration: "underline"
        }
      },
      key: submenu.subcategories[item].url
    }, __jsx(Link, {
      route: "category-page",
      params: submenu.subcategories[item]
    }, __jsx(_LinkRaw["default"], {
      title: submenu.subcategories[item].name
    }, submenu.subcategories[item].name))));
  })));
};
var _default = CategorySubmenu;
exports["default"] = _default;